import {
  faBadgePercent,
  faCalendarImage,
  faEarthAmericas,
  faFamily,
  faGem,
  faShip,
  faTreeCity,
  faPerson,
  faUmbrellaBeach,
} from '@fortawesome/pro-light-svg-icons'
import { ugSpaCalendar } from '../../CustomIcons/ugSpaCalendar'
import { type Icon, type Menu, type MenuItem, type WithId } from '../typings'
import antalya from './images/antalya.webp'
import deutschland from './images/deutschland.webp'
import hurghada from './images/hurghada.webp'
import kos from './images/kos.webp'
import kreta from './images/kreta.webp'
import mallorca from './images/mallorca.webp'
import rhodos from './images/rhodos.webp'
import side from './images/side.webp'

export const data: {
  main: Array<(Menu<Icon> & WithId) | MenuItem>
  category: Array<Menu>
} = {
  main: [
    {
      title: 'Unsere Empfehlungen',
      path: 'https://www.urlaubsguru.de/angebote/',
    },
    {
      title: 'Last Minute Angebote',
      path: 'https://www.urlaubsguru.de/last-minute/',
    },
    {
      title: 'All Inclusive',
      path: 'https://www.urlaubsguru.de/all-inclusive/',
    },
    {
      id: 'traveltypes',
      title: 'Reisearten',
      children: [
        {
          icon: faBadgePercent,
          path: 'https://www.urlaubsguru.de/fruehbucher/',
          title: 'Frühbucher Urlaub',
        },
        {
          icon: faUmbrellaBeach,
          path: 'https://www.urlaubsguru.de/pauschalreisen/',
          title: 'Pauschalreisen',
        },
        {
          icon: faFamily,
          path: 'https://www.urlaubsguru.de/familienurlaub/',
          title: 'Familienurlaub',
        },
        {
          icon: faPerson,
          path: 'https://www.urlaubsguru.de/singlereisen/',
          title: 'Singlereisen',
        },
        {
          icon: faCalendarImage,
          path: 'https://www.urlaubsguru.de/kurzreisen/',
          title: 'Kurzreisen',
        },
        {
          icon: faTreeCity,
          path: 'https://www.urlaubsguru.de/staedtereisen/',
          title: 'Städtereisen',
        },
        {
          icon: faEarthAmericas,
          path: 'https://www.urlaubsguru.de/rundreisen/',
          title: 'Rundreisen',
        },
        {
          icon: faShip,
          path: 'https://www.urlaubsguru.de/kreuzfahrten/',
          title: 'Kreuzfahrten',
        },
        {
          icon: ugSpaCalendar,
          path: 'https://www.urlaubsguru.de/wellness/',
          title: 'Wellness Wochenende',
        },
        {
          icon: faGem,
          path: 'https://www.urlaubsguru.de/luxusurlaub/',
          title: 'Luxusurlaub',
        },
      ],
    },
    {
      id: 'destinations',
      title: 'Beliebte Urlaubsziele',
      more: {
        path: 'https://www.urlaubsguru.de/urlaubsziele/',
        title: 'Alle Urlaubsziele',
      },
      children: [
        {
          icon: side,
          path: 'https://www.urlaubsguru.de/urlaubsziele/side/',
          title: 'Side',
          subTitle: 'Türkei',
        },
        {
          icon: mallorca,
          path: 'https://www.urlaubsguru.de/urlaubsziele/mallorca-urlaub/',
          title: 'Mallorca',
          subTitle: 'Spanien',
        },
        {
          icon: hurghada,
          path: 'https://www.urlaubsguru.de/urlaubsziele/hurghada/',
          title: 'Hurghada',
          subTitle: 'Ägypten',
        },
        {
          icon: kreta,
          path: 'https://www.urlaubsguru.de/urlaubsziele/kreta-urlaub/',
          title: 'Kreta',
          subTitle: 'Griechenland',
        },
        {
          icon: rhodos,
          path: 'https://www.urlaubsguru.de/urlaubsziele/rhodos/',
          title: 'Rhodos',
          subTitle: 'Griechenland',
        },
        {
          icon: kos,
          path: 'https://www.urlaubsguru.de/urlaubsziele/kos/',
          title: 'Kos',
          subTitle: 'Griechenland',
        },
        {
          icon: antalya,
          path: 'https://www.urlaubsguru.de/urlaubsziele/antalya/',
          title: 'Antalya',
          subTitle: 'Türkei',
        },
        {
          icon: deutschland,
          path: 'https://www.urlaubsguru.de/deutschlandliebe/',
          title: 'Deutschland',
        },
      ],
    },
  ],
  category: [
    {
      title: 'Unterkünfte',
      children: [
        {
          path: 'https://www.urlaubsguru.de/ferienwohnungen/',
          title: 'Ferienwohnungen',
        },
        { path: 'https://www.urlaubsguru.de/hotels/', title: 'Hotels' },
        {
          path: 'https://www.urlaubsguru.de/luxushotels/',
          title: 'Luxushotels',
        },
        {
          path: 'https://www.urlaubsguru.de/neue-hotels/',
          title: 'Hotel Neueröffnungen',
        },
        {
          path: 'https://www.urlaubsguru.de/aussergewoehnliche-unterkuenfte/',
          title: 'Außergewöhnliche Unterkünfte',
        },
        {
          path: 'https://www.urlaubsguru.de/wellness/wellnesshotels/',
          title: 'Wellnesshotels',
        },
        {
          path: 'https://www.urlaubsguru.de/hotel-des-tages/',
          title: 'Hotel-Tipp des Tages',
        },
      ],
    },
    {
      title: 'Reiseinformationen',
      children: [
        {
          path: 'https://www.urlaubsguru.de/reisemagazin/checkliste-fuer-den-sommerurlaub/',
          title: 'Checkliste für den Urlaub',
        },
        {
          path: 'https://www.urlaubsguru.de/reisemagazin/reiseapotheke-checkliste/',
          title: 'Reiseapotheke',
        },
        {
          path: 'https://www.urlaubsguru.de/reisemagazin/entschaedigung-flugverspaetung/',
          title: 'Entschädigung bei Flugverspätung',
        },
        {
          path: 'https://www.urlaubsguru.de/reisemagazin/essen-flugzeug-erlaubt/',
          title: 'Essen im Flugzeug',
        },
        {
          path: 'https://www.urlaubsguru.de/reisemagazin/tipps-gegen-flugangst/',
          title: 'Tipps gegen Flugangst',
        },
      ],
    },
    {
      title: 'Aktivitäten',
      children: [
        {
          path: 'https://www.urlaubsguru.de/sehenswuerdigkeiten/',
          title: 'Sehenswürdigkeiten',
        },
        {
          path: 'https://www.urlaubsguru.de/freizeitaktivitaeten/',
          title: 'Freizeitaktivitäten',
        },
        {
          path: 'https://www.urlaubsguru.de/reisemagazin/schoenste-orte-deutschland/',
          title: 'Schönste Orte Deutschland',
        },
        {
          path: 'https://www.urlaubsguru.de/skiurlaub/',
          title: 'Skiurlaub',
        },
        {
          path: 'https://www.urlaubsguru.de/reisekalender/silvester/',
          title: 'Silvester',
        },
      ],
    },
    {
      title: 'Inspiration & Tipps',
      children: [
        {
          path: 'https://www.urlaubsguru.de/reisekalender/',
          title: 'Reisekalender',
        },
        {
          path: 'https://www.urlaubsguru.de/reisekalender/reiseziele-monat/',
          title: 'Beste Reiseziele nach Monat',
        },
        {
          path: 'https://www.urlaubsguru.de/reisekalender/beste-reisezeit/',
          title: 'Beste Reisezeit',
        },
        {
          path: 'https://www.urlaubsguru.de/reisemagazin/',
          title: 'Reisemagazin',
        },
        {
          path: 'https://www.urlaubsguru.de/reisekalender/brueckentage/',
          title: 'Brückentage 2025',
        },
        {
          path: 'https://www.urlaubsguru.de/reiseplanung/',
          title: 'Reiseplanung 2025',
        },
        { path: 'https://www.urlaubsguru.de/lexikon/', title: 'Reiselexikon' },
      ],
    },
    {
      title: 'Services',
      children: [
        {
          path: 'https://anfrage.urlaubsguru.de/?p=reiseart',
          title: 'Reiseanfrage stellen',
        },
        {
          path: 'https://www.urlaubsguru.de/messenger/',
          title: 'Messenger Service',
        },
        { path: 'https://www.urlaubsguru.de/gutscheine/', title: 'Gutscheine' },
      ],
    },
  ],
}
